module.exports = __webpack_public_path__ + "img/8b089f2aa7c5328206cf4d43158857f6.png";